import React from 'react';
import styled from 'styled-components';
import { CheckBox } from '@estee/elc-checkbox';

interface CheckboxProps {
  isChecked: boolean;
  value: string;
  onChange(value: boolean): void;
  label: string;
  enabled?: boolean;
  className?: string;
  dataTestId?: string;
  labelId?: string;
  ariaLabeledBy?: string;
}

const ContainerCheckBox = styled.div`
  .elc-checkbox {
    display: flex;
  }
  .elc-checkbox-check-area {
    top: auto;
  }
  .elc-checkbox-icon {
    mask-size: 26px;
    -webkit-mask-size: 26px;
    width: 24px;
    height: 24px;
  }
  .elc-checkbox-label  {
    margin-left: 12px;
  }
`;

const CheckboxRC: React.FunctionComponent<CheckboxProps> = ({
  isChecked,
  value,
  onChange,
  label,
  enabled,
  className,
  dataTestId,
  labelId,
  ariaLabeledBy,
}) => (
  <ContainerCheckBox>
    <CheckBox
      value={value}
      isChecked={isChecked}
      onChange={onChange}
      label={label}
      enabled={enabled}
      className={className}
      dataTestId={dataTestId}
      labelId={labelId}
      aria-labelledby={ariaLabeledBy}
    />
  </ContainerCheckBox>
);

export default CheckboxRC;
